import Icon, { IconProps } from './Icon';

import DotsGridIcon from '../../../assets/icons/dots-grid.svg?react';

const DotsGrid: React.FC<Omit<IconProps, 'children'>> = (props) => {
    return (
        <Icon {...props}>
            <DotsGridIcon />
        </Icon>
    );
};

export default DotsGrid;
